module.exports = __webpack_public_path__ + "img/Banco_do_Brasil.3602d94b.svg";